import { LogsService } from "@gtpl/shared-services/user-logs";
import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Entity, Like, Repository, getManager } from "typeorm";
import { PurchasesEntity } from "./purchases.entity";
import { PurchaseProductsEntity } from "./purchases-product.entity";
import {  PurchaseProductDetailedReqDto, PurchaseProductFilterReq, PurchaseProductsInfo, PurchaseRequest } from "@gtpl/shared-models/finance";
import { GenericTransactionManager } from "apps/services/backend/typeorm-transactions/generic-transaction-manager";
import { CommonResponse, CompanyTypeEnum, PlantIdRequest } from "@gtpl/shared-models/masters";
import {UnitcodeService} from '../../../../../../libs/shared-services/masters/src/lib/unit-code.services'
import {UnitCodes} from '../../../../../services/masters/src/app/unit-codes/unit-codes.entity'
import appSettings from "apps/services/config";
import { log } from "util";
Injectable()
export class PurchasesService {
    constructor(
        @InjectRepository(PurchasesEntity)
        private repo: Repository<PurchasesEntity> ,
        @InjectRepository(PurchaseProductsEntity)
        private purchaseProductRepo: Repository<PurchaseProductsEntity>,
        private plantService: UnitcodeService
       
    ){ }
    async createPurchase(req:PurchaseRequest, isUpdate: boolean):Promise<CommonResponse>{
        const transactionManager = new GenericTransactionManager()
        const queryManger = getManager()

        try{
            await transactionManager.startTransaction()
            let saveFlag = new Set<Boolean>()
            const today = new Date();
            const CurrentYear = today.getFullYear();
            const CurrentMonth = today.getMonth();
            let fromDate = 0;
            let toDate = 0;
            let company
            let totalPO = await this.repo.count()
            let totalPOInd = await this.repo.count({where:{lotNumber: Like('%IND%')}});
            let totalPOExp = await this.repo.count({where:{lotNumber:Like('%EXP%')}});
            let totalPoOd = await this.repo.count({where:{lotNumber:Like('%OD%')}});
            console.log(totalPOExp,totalPOInd,totalPoOd,'counttttttttttttttt');

            if (CurrentMonth < 4) {
                fromDate = (CurrentYear-1);
                toDate = (CurrentYear );
            } else {
                fromDate = (CurrentYear);
                toDate = (CurrentYear + 1);
            }
            const plantReq = new PlantIdRequest(req.plantId)
            console.log(plantReq,'iiiiiiiiii');
            
            const plant = await this.plantService.getPlantDetailsById({unitcodeId:req.plantId})
            console.log(plant,'ooooooooooooooooooo');
            
        //    if(!isUpdate){
            const purchaseProducts =[]
            const enitity = new PurchasesEntity()
            enitity.purchaseId = req.purchaseId
            enitity.invoiceNumber = req.invoiceNumber
            enitity.unitId = req.plantId
            enitity.createdUser = req.createdUser
            enitity.vendorId = req.vendorId
            totalPO = totalPO + 1;
            let refNo 
            let createdYear = new Date().getFullYear()
            let createdMonth = new Date().getMonth() + 1
            console.log(plant.data?.company,'companyyyyyyyyyyyyyyyyy');
            // let refNo = `P${totalPO}/${company}`;
            let query
            if(createdMonth >= 4){
              query= `SELECT MAX(ref_no) as refNumber FROM ${appSettings.finance_db} .purchases g left join ${appSettings.masters_db} .unitcodes u on u.unit_code_id = g.unit_id where u.company = '${plant.data?.company}' and year(g.created_at) = ${createdYear} and month(g.created_at) >= 4 `
             
            }else{
              query = `SELECT MAX(ref_no) as refNumber FROM ${appSettings.finance_db} .purchases g left join ${appSettings.masters_db} .unitcodes u on u.unit_code_id = g.unit_id where u.company = '${plant.data?.company}' and year(g.created_at) = ${createdYear} and month(g.created_at) < 4`
            }
            const refinfo = await queryManger.query(query)
            if(refinfo.length > 0){
              refNo = refinfo[0].refNumber + 1
            }else{
              refNo = 1
            }
            
            if(plant.data?.company === CompanyTypeEnum.BMR_INDUSTRIES_PRIVATE_LIMITED){
                company = 'IND'
                // while (refNo.length < 4) refNo = "0" + refNo;
            } else if( plant.data?.company === CompanyTypeEnum.BMR_EXPORTS_AP){
                company = 'EXP'
                // while (refNo.length < 4) refNo = "0" + refNo;
            } else {
                company ="OD"
                // while (refNo.length < 4) refNo = "0" + refNo;

            }
        // toDate= Date.now()
        if (!isUpdate) {
          if (CurrentMonth < 4) {
            fromDate = (CurrentYear-1);
            toDate = (CurrentYear);
          } else {
            fromDate = (CurrentYear);
            toDate = (CurrentYear + 1);
          }
console.log(fromDate,toDate,'ppppppppppppp');

        }
        refNo = refNo + ''
        while (refNo.length < 4) refNo = "0" + refNo;
        const lotCode = 'P'+ refNo +'/'+ company+'/' + (fromDate.toString().substr(-2)) +'-'+ (toDate.toString().substr(-2))
        enitity.refNumber = refNo
            enitity.lotNumber = lotCode
            if(req.productsInfo.length>0){
                
            for(const products of req.productsInfo){
                console.log(req,'8888888');
                
                const productEntity = new PurchaseProductsEntity()
                productEntity.caseWeight = products.caseWeight
                productEntity.unitPrice = products.unitPrice
                productEntity.packStyleId = products.packStyleId
                productEntity.productId = products.productId
                productEntity.cases = products.cases
                productEntity.netWeight = products.netWeight
                productEntity.taxId = products.taxId
                productEntity.totalAmount = products.totalAmount
                productEntity.purchaseProductId = products.purchaseProductId
                console.log(productEntity,'oooooooo');
                
                purchaseProducts.push(productEntity)
                if (isUpdate) {
                    productEntity.purchaseProductId = products.purchaseProductId;
                    productEntity.updatedUser = products.updatedUser;
                  } else {
                    productEntity.createdUser = products.createdUser
                  }
                console.log(productEntity,'uuuuu');

            }
                    enitity.purchaseProductsInfo = purchaseProducts
                    console.log(enitity,'oooooooooooooooo');
                    
                    const purchaseSave = await transactionManager.getRepository(PurchasesEntity).save(enitity);
                    console.log(purchaseSave,'uuuuuuuuuuuuuuuuu');
                    
                    // const purchaseProductSave = await transactionManager.getRepository(PurchaseProductsEntity).save(productEntity);
                    if(!purchaseSave){
                        saveFlag.add(false)
                        await transactionManager.releaseTransaction()
                        return new CommonResponse(false,0,'Some thing went wrong in product purchase',[])
                        // break
                      }
            }else{
                return new CommonResponse(false,0,'Add atleast one product',[])
            }
                    
            if(!(saveFlag.has(false))){
                await transactionManager.completeTransaction()
                return new CommonResponse(true,1,'Saved successfully')
            }else{
                await transactionManager.releaseTransaction()
                return new CommonResponse(false,0,'Something went wrong in aproduct purchase')
            }
        }catch(err){
            await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong in aproduct purchase',err)
        }
    }
    async getAllProducts():Promise<CommonResponse>{  
        try{
        const manager = getManager();
        let query =`SELECT s.sku_code_id AS productId,s.short_code AS shortCode  FROM `+appSettings.masters_db+`.sku_codes s
        GROUP BY s.short_code`
        const details =await manager.query(query);
      return new CommonResponse(true, 1, 'No data found',details)
      
      } catch (err) {
      
        throw err
      }
      
      }

      async getViewForAllProducts(req:PurchaseProductFilterReq):Promise<CommonResponse>{  
        try{
        const manager = getManager();
        let query =`SELECT p.purchase_id,p.vendor_id,ve.vendor_name AS vendorName,p.unit_id,uc.unit_name AS unitName,uc.company,p.lot_number AS lotNumber,p.invoice_no AS invoiceNum,
        pp.unit_price AS unitPrice,pp.cases,pp.total_amount AS totalAmount,pp.case_weight AS caseWeight,ve.vendor_id,uc.unit_code_id,tx.tax_id,sku.sku_code_id,
        pp.net_weight AS netWeight,pp.tax_id,tx.tax_name AS taxName,tx.tax_percentage AS taxPercentage,pp.product_id,sku.short_code AS productName,pp.pack_style_id,pm.packing_method_name AS packingStyleName
        FROM `+appSettings.finance_db+`.purchases p
        LEFT JOIN `+appSettings.finance_db+`.purchase_products pp ON pp.purchase_id=p.purchase_id
        LEFT JOIN `+appSettings.masters_db+`.vendors ve ON ve.vendor_id=p.vendor_id
        LEFT JOIN `+appSettings.masters_db+`.unitcodes uc ON uc.unit_code_id=p.unit_id
        LEFT JOIN `+appSettings.masters_db+`.taxes tx ON tx.tax_id=pp.tax_id
        LEFT JOIN `+appSettings.masters_db+`.sku_codes sku ON sku.sku_code_id=pp.product_id
        LEFT JOIN `+appSettings.masters_db+`.packing_methods pm ON pm.packing_method_id=pp.pack_style_id where p.purchase_id > 0`
        
        if(req.vendorName){
            query += ` and ve.vendor_id = ${req.vendorName}`
          }
          if(req.company){
            query += ` and uc.unit_code_id = ${req.company}`
          }
          if(req.invoiceNum){
            query += ` and p.purchase_id = ${req.invoiceNum}`
          }
          if(req.unitId!=5){
            query += ` and uc.unit_code_id = ${req.unitId}`
          }
          query += ` GROUP BY p.purchase_id`
        const details =await manager.query(query);
      return new CommonResponse(true, 1, 'No data found',details)
      
      } catch (err) {
      
        throw err
      }
      
      }


      async getAllVendorNamesForView():Promise<CommonResponse>{  
        try{
        const manager = getManager();
        let query =`SELECT ve.vendor_id AS vendorId,ve.vendor_name AS vendorName FROM `+appSettings.masters_db+`.vendors ve`
        const details =await manager.query(query);
      return new CommonResponse(true, 1, 'No data found',details)
      
      } catch (err) {
      
        throw err
      }
      
      }


      async getAllInvoiceNumber():Promise<CommonResponse>{  
        try{
        const manager = getManager();
        let query =`SELECT p.purchase_id AS purchaseId,p.invoice_no AS invoiceNum FROM `+appSettings.finance_db+`.purchases p`
        const details =await manager.query(query);
      return new CommonResponse(true, 1, 'No data found',details)
      
      } catch (err) {
      
        throw err
      }
      
      }


      async getAllUnits(): Promise<CommonResponse> {
        try {
            const manager = getManager();
          let query = `SELECT uc.unit_code_id AS unitCodeId,uc.unit_name AS unitName,uc.company FROM ` + appSettings.masters_db+ `.unitcodes uc`
          const data = await manager.query(query);
      
          if (data.length > 0) {
            return new CommonResponse(true, 0, "data retrieved successfully", data)
          } else {
            return new CommonResponse(false, 1, "No data found", [])
          }
        } catch (err) {
          throw (err)
        }
      
      }

      async getDetailedViewForProductPurchase(req:PurchaseProductDetailedReqDto):Promise<CommonResponse>{  
        try{
        const manager = getManager();
        let query =`SELECT p.purchase_id,p.vendor_id,ve.vendor_name AS vendorName,p.unit_id,uc.unit_name AS unitName,p.lot_number AS lotNumber,p.invoice_no AS invoiceNum,
        pp.unit_price AS unitPrice,pp.cases,pp.total_amount AS totalAmount,pp.case_weight AS caseWeight,ve.vendor_id,uc.unit_code_id,tx.tax_id,sku.sku_code_id,
        pp.net_weight AS netWeight,pp.tax_id,tx.tax_name AS taxName,tx.tax_percentage AS taxPercentage,pp.purchase_id,pp.product_id,sku.short_code AS productName,pp.pack_style_id,pm.packing_method_name AS packingStyleName
        FROM `+appSettings.finance_db+`.purchases p
        LEFT JOIN `+appSettings.finance_db+`.purchase_products pp ON pp.purchase_id=p.purchase_id
        LEFT JOIN `+appSettings.masters_db+`.vendors ve ON ve.vendor_id=p.vendor_id
        LEFT JOIN `+appSettings.masters_db+`.unitcodes uc ON uc.unit_code_id=p.unit_id
        LEFT JOIN `+appSettings.masters_db+`.taxes tx ON tx.tax_id=pp.tax_id
        LEFT JOIN `+appSettings.masters_db+`.sku_codes sku ON sku.sku_code_id=pp.product_id
        LEFT JOIN `+appSettings.masters_db+`.packing_methods pm ON pm.packing_method_id=pp.pack_style_id 
        WHERE 
        p.purchase_id = '${req.purchaseId}'`
    
        const details =await manager.query(query);
      return new CommonResponse(true, 1, 'No data found',details)
      
      } catch (err) {
      
        throw err
      }
      
      }

      async getPurchaseProductReport():Promise<CommonResponse>{  
        try{
        const manager = getManager();
        let query =`SELECT p.purchase_id,p.vendor_id,p.unit_id,p.lot_number AS lotNumber,p.invoice_no AS invoiceNumber,
        DATE(p.created_at) AS createdAt,pp.product_id,pp.pack_style_id,
        pp.unit_price AS unitPrice,pp.cases,pp.total_amount AS totalAmount,pp.case_weight AS caseWeight,
        pp.net_weight AS netWeight,pp.tax_id,pm.packing_method_name AS packStyleName,
        sku.short_code AS productName,t.tax_percentage AS tax,ve.vendor_name AS vendorName,uc.unit_name AS unitName,uc.company        
        FROM `+appSettings.finance_db+`.purchases p
        LEFT JOIN `+appSettings.finance_db+`.purchase_products pp ON pp.purchase_id=p.purchase_id
        LEFT JOIN `+appSettings.masters_db+`.vendors ve ON ve.vendor_id=p.vendor_id
        LEFT JOIN `+appSettings.masters_db+`.unitcodes uc ON uc.unit_code_id=p.unit_id
        LEFT JOIN `+appSettings.masters_db+`.taxes tx ON tx.tax_id=pp.tax_id
        LEFT JOIN `+appSettings.masters_db+`.sku_codes sku ON sku.sku_code_id=pp.product_id
        LEFT JOIN `+appSettings.masters_db+`.packing_methods pm ON pm.packing_method_id=pp.pack_style_id where p.purchase_id > 0`
        
        const details =await manager.query(query);
      return new CommonResponse(true, 1, 'No data found',details)
      
      } catch (err) {
      
        throw err
      }
      
      }
      
}